import { render, staticRenderFns } from "./FormServizioClienti.vue?vue&type=template&id=2c34d79c"
import script from "./FormServizioClienti.vue?vue&type=script&lang=js"
export * from "./FormServizioClienti.vue?vue&type=script&lang=js"
import style0 from "./FormServizioClienti.vue?vue&type=style&index=0&id=2c34d79c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports